import "./App.css";
// import CreateVideos from "./components/CreateVideos";
// import CreateVideosCheckout from "./components/CreateVideos/CreateVideosCheckout";
import "./custom.scss";
import "react-image-lightbox/style.css";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { httpRequest } from "./utils/networkCalls";
import { updateToken, logOut } from "./utils/common";
import get from "lodash/get";
import history from "./utils/history";
import { useDispatch, useSelector } from "react-redux";
import {
    aiMhFetchSubDetails,
    aiMhUpdateSubDetails,
} from "./store/AiMarketingHub/AimhLandingPage/AimhLpReducer";
import {
    AgentsBio,
    AiMarketingHub,
    Coupons,
    EmailGeneration,
    Flyer,
    History,
    Home,
    MyOrders,
    MyProfile,
    MyTeam,
    MyVideos,
    NotFound,
    PropertyDescription,
    Referral,
    RewriteParagraph,
    ServiceCheckout,
    Services,
    Sidebar,
    SocialMediaCaption,
    StyleGuide,
    Success,
    Support,
    Topbar,
} from "./utils/LazyLoad";
import { Suspense } from "react";
import Loader from "./components/Utilities/Loader";
import { ErrorBoundary } from "react-error-boundary";
import { ErrorBoundaryLayout } from "./components/ErrorBondary/ErrorBoundaryLayout";

export const UsrProfileImg = React.createContext();
function App() {
    const aiMhLpState = useSelector((state) => state.AimhLpReducer);
    const dispatch = useDispatch();
    const [isActive, setIsActive] = useState("");

    //For service progress bar
    const [pbStep, setPbStep] = useState("");

    //For service form
    const [stype, setStype] = useState("");
    const [showOrdForm, setShowOrdForm] = useState(false);
    const [showPeForm, setShowPeForm] = useState(false);
    const [showPwvForm, setShowPwvForm] = useState(false);
    const [showAvForm, setShowAvForm] = useState(false);
    const [isToggle, setToggle] = useState(false);

    // const userDetails = {
    //   displayName: "Vineet Prasad Verma",
    //   email: "ruturaj@styldod.com",
    //   phone: "8989673944",
    // };

    const [userDetails, setUserDetails] = useState("");
    const [userImg, setUserImg] = useState("");

    useEffect(() => {
        const token = localStorage.getItem("styldod-token");
        if (!token) window.location.href = `/login`;
        const fetchUD = async () => {
            let fetchUsrDetails = await httpRequest(
                "/user/getuser",
                "post",
                {}
            );
            // if (
            //     get(fetchUsrDetails, "data.error.code", "") ===
            //     "auth/id-token-expired"
            // ) {
            //     await updateToken();
            //     fetchUsrDetails = await httpRequest(
            //         "/user/getuser",
            //         "post",
            //         {}
            //     );
            // }
            fetchUsrDetails.status !== "registred" && logOut();
            setUserDetails(fetchUsrDetails.data);
            setUserImg(fetchUsrDetails["data"]["avtar"]);
        };
        fetchUD();
        // setUserDetails({
        //     email: "rohit.thorat@styldod.com",
        //     name: "Rohit Thorat",
        // });
    }, []);

    useEffect(() => {
        if (userDetails !== "") {
            dispatch(aiMhFetchSubDetails({ userDetails: userDetails }));
        }
    }, [userDetails]);

    function FallbackComponent({ error, resetErrorBoundary }) {
        return (
            <ErrorBoundaryLayout 
             error={error}
             resetErrorBoundary={resetErrorBoundary}
            />
        );
    }

    return (
        <ErrorBoundary
            FallbackComponent={FallbackComponent}
            onReset={() => {
                history.push('/')
            }}
        >
            <UsrProfileImg.Provider value={{ userImg, setUserImg }}>
                <div className="App" style={{ height: "100vh" }}>
                    <div
                        className="ud-main-cont"
                        style={{ display: "flex", minHeight: "100%" }}
                    >
                        {userDetails === "" ? (
                            ""
                        ) : (
                            <Suspense
                                fallback={
                                    <div
                                        style={{
                                            top: "50%",
                                            left: "50%",
                                            position: "absolute",
                                        }}
                                    >
                                        <Loader type={"spin"} color={"#a6df50"} />
                                    </div>
                                }
                            >
                                <Router history={history}>
                                    <Sidebar
                                        isActive={isActive}
                                        setIsActive={setIsActive}
                                        isToggle={isToggle}
                                        setToggle={setToggle}
                                        setStype={setStype}
                                        setShowOrdForm={setShowOrdForm}
                                        setShowAvForm={setShowAvForm}
                                        setPbStep={setPbStep}
                                    />
                                    <div
                                        style={{
                                            width: "100%",
                                            // marginBottom: "40px",
                                            paddingLeft:
                                                window.screen.width > 767
                                                    ? "80px"
                                                    : "",
                                        }}
                                    >
                                        <Topbar
                                            userDetails={userDetails}
                                            isToggle={isToggle}
                                            setToggle={setToggle}
                                            isActive={isActive}
                                            setIsActive={setIsActive}
                                            pbStep={pbStep}
                                            stype={stype}
                                            setStype={setStype}
                                            setShowOrdForm={setShowOrdForm}
                                            setShowPeForm={setShowPeForm}
                                            showPeForm={showPeForm}
                                            setShowPwvForm={setShowPwvForm}
                                            showPwvForm={showPwvForm}
                                            showAvForm={showAvForm}
                                            setShowAvForm={setShowAvForm}
                                        />

                                        <Switch>
                                            <Route exact path="/">
                                                <Home
                                                    setIsActive={setIsActive}
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/my-orders">
                                                <MyOrders
                                                    email={userDetails.email}
                                                    setIsActive={setIsActive}
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/services">
                                                <Services
                                                    userDetails={userDetails}
                                                    setIsActive={setIsActive}
                                                    isActive={isActive}
                                                    setPbStep={setPbStep}
                                                    stype={stype}
                                                    setStype={setStype}
                                                    showOrdForm={showOrdForm}
                                                    setShowOrdForm={setShowOrdForm}
                                                    setShowPeForm={setShowPeForm}
                                                    showPeForm={showPeForm}
                                                    setShowPwvForm={setShowPwvForm}
                                                    showPwvForm={showPwvForm}
                                                    showAvForm={showAvForm}
                                                    setShowAvForm={setShowAvForm}
                                                />
                                            </Route>

                                            <Route path="/style-guide">
                                                <StyleGuide />
                                            </Route>

                                            {/* <Route path="/create-videos">
                                            <CreateVideos
                                                userDetails={userDetails}
                                                setIsActive={setIsActive}
                                                setPbStep={setPbStep}
                                                pbStep={pbStep}
                                            />
                                        </Route>

                                        <Route path="/create-videos-checkout">
                                            <CreateVideosCheckout />
                                        </Route> */}

                                            <Route path="/property-videos">
                                                <MyVideos
                                                    userDetails={userDetails}
                                                    setIsActive={setIsActive}
                                                    setStype={setStype}
                                                />
                                            </Route>

                                            <Route path="/coupons">
                                                <Coupons
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/my-profile">
                                                <MyProfile />
                                            </Route>

                                            <Route path="/referrals">
                                                <Referral
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/my-team">
                                                <MyTeam userDetails={userDetails} />
                                            </Route>

                                            <Route path="/support">
                                                <Support
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/ai-marketinghub">
                                                <AiMarketingHub
                                                    setIsActive={setIsActive}
                                                    setPbStep={setPbStep}
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/property-description">
                                                <PropertyDescription
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/marketing-emails">
                                                <EmailGeneration
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/rewrite-content">
                                                <RewriteParagraph
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/social-media-captions">
                                                <SocialMediaCaption
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/agent's-bio">
                                                <AgentsBio
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/history">
                                                <History
                                                    userDetails={userDetails}
                                                />
                                            </Route>

                                            <Route path="/flyers">
                                                <Flyer
                                                    userDetails={userDetails}
                                                    setIsActive={setIsActive}
                                                    setPbStep={setPbStep}
                                                />
                                            </Route>

                                            <Route path="/payment-successful">
                                                <div>
                                                    <div className="ud-place-neworder">
                                                        <Success
                                                            userDetails={
                                                                userDetails
                                                            }
                                                            setIsActive={
                                                                setIsActive
                                                            }

                                                            setStype={setStype}
                                                            setShowAvForm={setShowAvForm}
                                                        />
                                                    </div>
                                                </div>
                                            </Route>
                                            <Route path="/services-checkout">
                                                <ServiceCheckout />
                                            </Route>
                                            <Route path="/*">
                                                <NotFound />
                                            </Route>
                                        </Switch>
                                    </div>
                                </Router>
                            </Suspense>
                        )}
                    </div>
                </div>
            </UsrProfileImg.Provider>
        </ErrorBoundary>
    );
}

export default App;
